import { dataDecreaseWidth } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDecreaseWidth = /*#__PURE__*/createIcon(dataDecreaseWidth)
export default IconDecreaseWidth
